import React, { Component } from 'react';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import {
    Mail,
    Person,
    Notifications,
    Home,
    Edit,
    Favorite,
    LocalOffer,
    Money,
    Info,
    ListAlt,
    Email,
    AttachMoney
} from '@material-ui/icons';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import { Link } from 'react-router-dom';
import { withTheme, withStyles } from '@material-ui/core/styles';
import { compose } from 'redux';
import { ROLE_CUSTOMER, ROLE_PROVIDER } from '../../utils/config/constants';
import { FormattedMessage, injectIntl } from 'react-intl';
import { store } from '../../store';

const styles = theme => ({
    listItem: {
        color: theme.palette.primary.text
    },
    icon: {
        color: theme.palette.primary.text
    }
});
const navbarItems = [
    {
        key: 'home',
        label: 'Home',
        renderContent: classes => <Home className={classes.icon} />,
        link: '/'
    },
    {
        key: 'notifications',
        label: 'Notifications',
        renderContent: classes => <Notifications className={classes.icon} />,
        link: '/notification/list'
    },
    {
        key: 'inbox',
        label: 'Inbox',
        renderContent: classes => <Email className={classes.icon} />,
        link: '/user/chat'
    },
    {
        key: 'address',
        label: 'Addresses',
        renderContent: classes => <Home className={classes.icon} />,
        link: '/user/address'
    },
    {
        key: 'booking',
        label: 'Manage Requests',
        renderContent: classes => <Edit className={classes.icon} />,
        link: '/user/booking'
    },
    {
        key: 'newbooking',
        label: 'Add New Request',
        renderContent: classes => <Edit className={classes.icon} />,
        link: '/'
    },

    {
        key: 'favourite',
        label: 'Favourites',
        renderContent: classes => <Favorite className={classes.icon} />,
        link: '/user/favourite'
    },
    {
        key: 'promo',
        label: 'Offers',
        renderContent: classes => <LocalOffer className={classes.icon} />,
        link: '/promocode/list'
    }
    // {
    //     key: 'help',
    //     label: 'Help',
    //     renderContent: classes => <Info className={classes.icon} />,
    //     link: '/user/help'
    // }
];
const navbarProviderItems = [
    {
        key: 'home',
        label: 'Home',
        renderContent: classes => <Home className={classes.icon} />,
        link: '/user/dashboard'
    },

    {
        key: 'notification',
        label: 'Notifications',
        renderContent: classes => <Notifications className={classes.icon} />,
        link: '/notification/list'
    },
    {
        key: 'inbox',
        label: 'Inbox',
        renderContent: classes => <Email className={classes.icon} />,
        link: '/user/chat'
    },

    {
        key: 'address',
        label: 'Addresses',
        renderContent: classes => <Home className={classes.icon} />,
        link: '/user/address'
    },
    {
        key: 'revenue',
        label: 'Revenue',
        renderContent: classes => <AttachMoney className={classes.icon} />,
        link: '/user/revenue'
    },
    {
        key: 'booking',
        label: 'Manage Requests',
        renderContent: classes => <Edit className={classes.icon} />,
        link: '/provider/booking'
    },
    // {
    //     key: 'myEarnings',
    //     label: 'My Earnings',
    //     renderContent: classes => <Money className={classes.icon} />,
    //     link: '/provider/earning'
    // },
    {
        key: 'service',
        label: 'Manage Services',
        renderContent: classes => <ListAlt className={classes.icon} />,
        link: '/provider/service'
    },
    {
        key: 'addservice',
        label: 'Add Service',
        renderContent: classes => <Edit className={classes.icon} />,
        link: '/provider/service/create'
    }
    // {
    //     key: 'help',
    //     label: 'Help',
    //     renderContent: classes => <Info className={classes.icon} />,
    //     link: '/user/help'
    // }
];
export class SideNav extends Component {
    renderCustomerNavbar = formatMessage => {
        {
            return navbarItems.map(n => {
                return (
                    <li key={n.key}>
                        <Link to={n.link}>
                            <ListItemIcon>
                                {n.renderContent(this.props.classes)}
                            </ListItemIcon>
                            <ListItemText
                                className={
                                    this.props.classes.listItem + ' pl-0'
                                }
                                primary={formatMessage({
                                    id: n.key
                                })}
                                primaryTypographyProps={{
                                    className: this.props.classes.listItem
                                }}
                            />
                        </Link>
                    </li>
                );
            });
        }
    };

    renderProviderNavbar = formatMessage => {
        {
            return navbarProviderItems.map(n => {
                return (
                    <li key={n.key}>
                        <Link to={n.link}>
                            <ListItemIcon>
                                {n.renderContent(this.props.classes)}
                            </ListItemIcon>
                            <ListItemText
                                className={
                                    this.props.classes.listItem + ' pl-0'
                                }
                                primary={formatMessage({
                                    id: n.key
                                })}
                                primaryTypographyProps={{
                                    className: this.props.classes.listItem
                                }}
                            />
                        </Link>
                    </li>
                );
            });
        }
    };
    render() {
        const { formatMessage } = this.props.intl;
        const {} = this.props;
        return (
            <List>
                {this.props.userData.role == ROLE_CUSTOMER &&
                    this.renderCustomerNavbar(formatMessage)}

                {this.props.userData.role == ROLE_PROVIDER &&
                    this.renderProviderNavbar(formatMessage)}
            </List>
        );
    }
}
const composedComponent = compose(
    withTheme(),
    withStyles(styles)
);

export default composedComponent(injectIntl(SideNav));



// WEBPACK FOOTER //
// ./src/views/SideBar/SideNav.jsx